import InitialBlockProvider, {
  useInitialBlockState,
  useInitialBlockActions,
} from './Provider';

export default InitialBlockProvider;
export { useInitialBlockState, useInitialBlockActions };
